import { useSyncExternalStore } from 'react';

function subscribe(onStoreChange: () => void) {
  window.addEventListener('online', onStoreChange);
  window.addEventListener('offline', onStoreChange);

  return () => {
    window.removeEventListener('online', onStoreChange);
    window.removeEventListener('offline', onStoreChange);
  };
}

/**
 * Reports whether the browser believes this device has a network connection.
 *
 * Treat the answer as a hint and never as a gate. The browser decides by looking for any connected
 * interface, so a machine whose only live interfaces are virtual -- a Nebula tunnel, say -- reports
 * itself online with the physical network down. A `false` is trustworthy; a `true` only rules out
 * the most obvious cause.
 *
 * React Query's `onlineManager` is deliberately not the source. It seeds itself to `true` and only
 * ever changes in response to an `online`/`offline` event, so it claims a connection on a page that
 * loaded without one.
 */
export function useIsOnline() {
  return useSyncExternalStore(subscribe, () => navigator.onLine);
}
